<script setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

// I18n
const { t } = useI18n()

// Variables
const isLoading = ref(true)
const adLoaded = ref(false)

onMounted(() => {
  // Check if ad loaded after a short delay
  setTimeout(() => {
    const adElement = document.querySelector('.adsbygoogle')
    if (adElement && adElement.innerHTML.trim() !== '') {
      adLoaded.value = true
    }
  }, 1000)
})

</script>

<template>
  <div class="grow">
    <div class="flex flex-col mx-auto px-10 py-6 h-full w-full">
      <div v-if="adLoaded" class="flex w-full justify-center mb-4 max-h-[90px]">
        <component is="script" async
                   src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9802466654600169"
                   crossorigin="anonymous"></component>
        <ins
          class="adsbygoogle"
          style="display:inline-block;width:728px;height:90px"
          data-ad-client="ca-pub-9802466654600169"
          data-ad-slot="2293253706"></ins>
        <component is="script">
          (adsbygoogle = window.adsbygoogle || []).push({});
        </component>
      </div>

      <hr v-if="adLoaded" class="my-8" />

      <router-view />
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import '@/assets/styles/views/service_providers/service_providers';
</style>
